/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'

import { 
  useGET_courseComponentsQuery,
} from 'redux/api/coursesApi'

import { 
  useGET_setupOptionsQuery,
  usePOST_setupOptionEnableMutation,
  usePOST_setupOptionDisableMutation 
} from 'redux/api/setupApi'

import { Form, Formik } from 'formik'
import CheckboxField from 'components/atoms/fields/CheckboxField'

const SyllabusSetupAcademicForm: FC = () => {
  const { t } = useTranslation()

  const { data: gradingItems } = useGET_courseComponentsQuery({page: 1, default_only: 'true'})
  const { data: setupData } = useGET_setupOptionsQuery()
  const [enableOption, {isLoading: isEnableLoading, isSuccess: isEnableSuccess, error: enableError}] = usePOST_setupOptionEnableMutation()
  const [disableOption, {isLoading: isDisableLoading, isSuccess: isDisableSuccess, error: disableError}] = usePOST_setupOptionDisableMutation()


  const amountOptions = [
    {key: 'syllabus_amount_yearly', label: t('setup-syllabus-main.amount-yearly')},
    {key: 'syllabus_amount_monthly', label: t('setup-syllabus-main.amount-monthly'),},
    {key: 'syllabus_amount_weekly', label: t('setup-syllabus-main.amount-weekly')},
  ]

  const frequencyOptions = [
    {key: 'syllabus_frequency_per_year', label: t('setup-syllabus-main.frequency-per-year')},
    {key: 'syllabus_frequency_per_month', label: t('setup-syllabus-main.frequency-per-month')},
    {key: 'syllabus_frequency_per_week', label: t('setup-syllabus-main.frequency-per-week')},
  ]


  const serverValues = setupData ? {
    syllabus_activity: [
      {
        key: 'syllabus_activity',
        label: t('common.activity'),
        is_enabled: setupData.filter(s => s.slug == 'syllabus_activity' && s.is_enabled).length == 1
      },
    ],
    options: gradingItems?.results?.map(item => {return {
      key: item.id,
      title: item.title,
      enabled: true
    }}) ?? [],
    
    syllabus_amount: [
      {
        key: 'syllabus_amount',
        label: t('common.amount'),
        is_enabled: setupData.filter(s => s.slug == 'syllabus_amount' && s.is_enabled).length == 1
      },
    ],
    amountOptions: amountOptions.map(o => {
      return {
        ...o,
        is_enabled: setupData.filter(s => s.slug == o.key && s.is_enabled).length == 1
      }
    }),

    syllabus_frequency: [
      {
        key: 'syllabus_frequency',
        label: t('common.frequency'),
        is_enabled: setupData.filter(s => s.slug == 'syllabus_frequency' && s.is_enabled).length == 1
      },
    ],
    frequencyOptions: frequencyOptions.map(o => {
      return {
        ...o,
        is_enabled: setupData.filter(s => s.slug == o.key && s.is_enabled).length == 1
      }
    }),

  }: null



  return (
    <>{serverValues && gradingItems &&
    <Formik
      enableReinitialize
      initialValues={serverValues}
      onSubmit={(values) => {
      }}
    >
      {
        ({ values, setFieldValue, errors }) => 
        <Form>
            <Grid rowSpacing={4} columnSpacing={4} container alignSelf='baseline' mb={2}>
                <Grid item xs={12} md={4} >
                  <div className="setup-section-title">
                    <CheckboxField
                      isSwitch={true}
                      hasLine={true}
                      index={0}
                      valueSelector='is_enabled'
                      fieldProps={{
                        label: values.syllabus_activity[0].label,
                        name: `syllabus_activity[0]`
                      }} 
                      onChange={(value)=> {
                        if(value.is_enabled)enableOption(values.syllabus_activity[0].key)
                        else disableOption(values.syllabus_activity[0].key)
                      }}
                    />
                  </div> 
                  {values.syllabus_activity[0].is_enabled && values["options"].map((option,index) => 
                    <div style={{ marginTop: '10px' }} key={`option-${index}`}>
                        <CheckboxField 
                          isSwitch={true}
                          hasLine={true}
                          index={index}
                          valueSelector='enabled'
                          fieldProps={{
                            label: option.title,
                            name: `options[${index}]`
                          }} 
                          onChange={(value)=> {
                            //TODO: enable/disable item
                          }}
                        />
                  </div>
                  )}
                </Grid>
                <Grid item xs={12} md={4}>       
                  <div className="setup-section-title">
                    <CheckboxField
                      isSwitch={true}
                      hasLine={true}
                      index={0}
                      valueSelector='is_enabled'
                      fieldProps={{
                        label: values.syllabus_amount[0].label,
                        name: `syllabus_amount[0]`
                      }} 
                      onChange={(value)=> {
                        if(value.is_enabled)enableOption(values.syllabus_amount[0].key)
                        else disableOption(values.syllabus_amount[0].key)
                      }}
                    />
                  </div>
                  {values.syllabus_amount[0].is_enabled && values["amountOptions"].map((option,index) => 
                    <div style={{ marginTop: '10px' }} key={`amount-${index}`}>
                        <CheckboxField 
                          isSwitch={true}
                          hasLine={true}
                          index={index}
                          valueSelector='is_enabled'
                          fieldProps={{
                            label: option.label,
                            name: `amountOptions[${index}]`
                          }}
                          onChange={(value)=> {
                            if(value.is_enabled)enableOption(option.key)
                            else disableOption(option.key)
                          }}
                        />
                  </div>
                  )}
                </Grid>     
                <Grid item xs={12} md={4}>       
                  <div className="setup-section-title">
                    <CheckboxField
                      isSwitch={true}
                      hasLine={true}
                      index={0}
                      valueSelector='is_enabled'
                      fieldProps={{
                        label: values.syllabus_frequency[0].label,
                        name: `syllabus_frequency[0]`
                      }} 
                      onChange={(value)=> {
                        if(value.is_enabled)enableOption(values.syllabus_frequency[0].key)
                        else disableOption(values.syllabus_frequency[0].key)
                      }}
                    />
                  </div>
                  {values.syllabus_frequency[0].is_enabled && values["frequencyOptions"].map((option,index) => 
                    <div style={{ marginTop: '10px' }} key={`frequency-${index}`}>
                       <CheckboxField 
                         isSwitch={true}
                         hasLine={true}
                         index={index}
                         valueSelector='is_enabled'
                         fieldProps={{
                           label: option.label,
                           name: `frequencyOptions[${index}]`
                         }}
                         onChange={(value)=> {
                           if(value.is_enabled)enableOption(option.key)
                           else disableOption(option.key)
                         }}
                       />
                    </div>
                  )}
                </Grid>   

            </Grid>
        </Form>
      }
    </Formik>
    }</>
  )
}
export default SyllabusSetupAcademicForm

